import { createInitialDemoStore } from './fixtures.js';

let store = createInitialDemoStore();
let writeToastCallback = null;

export function resetDemoStore() {
  store = createInitialDemoStore();
}

export function getDemoStore() {
  return store;
}

export function setDemoWriteToastCallback(fn) {
  writeToastCallback = fn;
}

function notifyDemoWrite() {
  if (writeToastCallback) {
    writeToastCallback('Demo mode — your change is shown locally but not saved to production.');
  }
}

function pathKey(segments) {
  return segments.filter(Boolean).join('/');
}

export function getCollectionData(collectionPath) {
  const key = pathKey(collectionPath);
  const data = store[key];
  if (!data || Array.isArray(data)) return {};
  return data;
}

export function getDocumentData(collectionPath, docId) {
  const col = getCollectionData(collectionPath);
  return col[docId] || null;
}

export function setDocumentData(collectionPath, docId, data, merge = false) {
  const key = pathKey(collectionPath);
  if (!store[key]) store[key] = {};
  store[key][docId] = merge ? { ...store[key][docId], ...data } : data;
  notifyDemoWrite();
}

export function deleteDocumentData(collectionPath, docId) {
  const key = pathKey(collectionPath);
  if (store[key]) {
    delete store[key][docId];
    notifyDemoWrite();
  }
}

export function addDocumentData(collectionPath, data) {
  const key = pathKey(collectionPath);
  if (!store[key]) store[key] = {};
  const id = `demo-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
  store[key][id] = data;
  notifyDemoWrite();
  return id;
}

export function listDocuments(collectionPath, filters = [], orderField = null, limitCount = null) {
  const col = getCollectionData(collectionPath);
  let entries = Object.entries(col).map(([id, data]) => ({ id, data }));

  for (const filter of filters) {
    const [field, op, value] = filter;
    if (op === '==') {
      entries = entries.filter((e) => e.data[field] === value);
    } else if (op === '>=') {
      entries = entries.filter((e) => {
        const v = e.data[field];
        if (v?.seconds != null && value?.seconds != null) return v.seconds >= value.seconds;
        return v >= value;
      });
    } else if (op === '<=') {
      entries = entries.filter((e) => {
        const v = e.data[field];
        if (v?.seconds != null && value?.seconds != null) return v.seconds <= value.seconds;
        return v <= value;
      });
    }
  }

  if (orderField) {
    entries.sort((a, b) => {
      const av = a.data[orderField];
      const bv = b.data[orderField];
      const an = av?.seconds ?? av;
      const bn = bv?.seconds ?? bv;
      if (an < bn) return -1;
      if (an > bn) return 1;
      return 0;
    });
  }

  if (limitCount) {
    entries = entries.slice(0, limitCount);
  }

  return entries;
}